import { Context } from "./jobs-wrapper";
import { useState, useContext } from "react";
import {cleanJobTitle, buildJobURL, removeMainCat, formatShortDate, RemovePageQSFromURL, scrollToTopOfJobs, FixAnyOfTheseJobType, JobDetailPreview} from '../helpers/helpers.js';



const JobResults = () => {
    const {data, loading, updateJobParams, pageIndex, updatePageIndex} = useContext(Context);
    //const [pageIndex, setPageIndex] = useState(1); //page click on or currently on

    const [paginationParamLoaded, setPaginationParamLoaded] = useState(false); //checks if page QS loads to ensure it only runs once and avoids a loop
    
    const resultsPerPage = 20;
    const pagesToOneThousandResults = (1000/resultsPerPage);
    const dataIndex = Math.ceil(pageIndex / pagesToOneThousandResults) //grouping of results i.e., first 1k=1, second 1k=2, etc up to 10 (10k results)
    const resultsOffsetFirst = pageIndex - ((dataIndex-1) * pagesToOneThousandResults); //sets the offset num of results i.e., pageIndex3 - (dataIndex3-1) * 100
    const resultsOffset = (resultsOffsetFirst-1) * resultsPerPage // the final offset i.e., page 1 === (1-1) * 10 = 0, page 2 === (2-1) * 10 = 10, page 3 === (3-1) * 10 = 20, 
    const urlParams = new URLSearchParams(window.location.search);
    const paginationParam = (urlParams.get('pg')) ? parseInt(urlParams.get('pg')) : null;


    //console.log ("window.were_facets_used: " + window.were_facets_used);
    //console.log("dataIndex: " +dataIndex);
    //console.log("Da Data: " + JSON.stringify(data));
    //console.log("isLoading " + loading);

    const buildPagination = (num_results, results_per_page) => {
        let num_of_pages = Math.ceil(num_results/results_per_page);
        //console.log("buildPagination curr page: " + pageIndex);

       

        if (num_results > results_per_page){
            const curr_path = window.location.pathname;
            return (
                <nav aria-label="Job Listing Page Navigation" class="col-xs-12 pl-0 pr-0">
                    <span class="pagination col-sm-12 col-xs-12 pl-0 pr-0">
                        <span>{pageIndex !== 1 ? <a href={curr_path+((pageIndex-1 !== 1) ? "?pg=" + (pageIndex-1) : "")} title="Previous Page" class="col-sm-3 col-xs-3 nextBtn" onClick={e => pageClick(e, (pageIndex-1))}><span>Previous</span></a> : <span class="col-sm-3 col-xs-3 disabled" aria-hidden="true">Previous</span>}</span>
                        <>
                            {
                            (() => {
                            
                                if (num_of_pages > 5) {

                                    return(
                                        <>
                                        {(pageIndex > 2) && <span class="numbrItem firstPage"><a href={curr_path} onClick={e => pageClick(e, 1)}>1</a></span>} {/*Add first page*/}
                                        {(pageIndex > 3) && <span class="numbrItem ellipse"><span><span>&hellip;</span></span></span>} {/*Add elipsis*/}

                                        {/*add "3 in a row"*/}
                                        {(pageIndex === num_of_pages) && <span class="numbrItem lastPage"><a href={curr_path+"?pg=" + (pageIndex- 2)} onClick={e => pageClick(e, (pageIndex-2))}>{pageIndex- 2}</a></span>} {/*add a -2 page if max page*/}
                                        {(pageIndex > 1) && <span class="numbrItem"><a href={curr_path+((pageIndex-1 !== 1) ? "?pg=" + (pageIndex-1) : "")} onClick={e => pageClick(e, (pageIndex-1))}>{pageIndex- 1}</a></span>} {/*dont add -1 page if page 1*/}
                                        <span class="numbrItem current"><span class="current">{pageIndex}</span></span>
                                        {(pageIndex < num_of_pages) && <span class="numbrItem"><a href={curr_path+"?pg=" + (pageIndex+ 1)} onClick={e => pageClick(e, (pageIndex+1))}>{pageIndex+ 1}</a></span>} {/*dont add a +1 if max page*/}
                                        {(pageIndex === 1) && <span class="numbrItem"><a href={curr_path+"?pg=" + (pageIndex + 2)} onClick={e => pageClick(e, (pageIndex+2))}>{pageIndex+ 2}</a></span>} {/*add a -2 page if page 1*/}

                                        {/*TEMP*/}
                                        {/*<li><a href="?pg=101" onClick={e => pageClick(e, 101)}>101</a></li>*/} 
                                        {/*<li><a href="?pg=999" onClick={e => pageClick(e, 999)}>999</a></li>*/} 
                                        {/*<li><a href="?pg=1001" onClick={e => pageClick(e, 1001)}>1001</a></li>*/} 
                                        {/*END TEMP*/}
                                    
                                        {
                                            pageIndex < (num_of_pages - 1) ? (
                                                <>
                                                {pageIndex < (num_of_pages - 2) && <span class="numbrItem ellipse"><span><span>&hellip;</span></span></span>}
                                                <span class="numbrItem"><a href={curr_path+"?pg=" + num_of_pages} onClick={e => pageClick(e, num_of_pages)}>{num_of_pages}</a></span>
                                                </>
                                            )
                                            :
                                            null
                                        }      
                                        </>
                                    )
                                }
                                else {
                                    let li_content = [];
                                    for (var i = 1; i <= num_of_pages; i++) {
                                        //console.log("i: " + i + ", pageIndex: " + pageIndex);
                                        const newI = i;
                                        if (i === pageIndex) {
                                            li_content.push(<span class="numbrItem current"><span class="current">{pageIndex}</span></span>);
                                        } else {
                                            li_content.push(<span class="numbrItem"><a href={curr_path+"?pg=" + i} onClick={e => pageClick(e, newI)}>{i}</a></span>);
                                        }
                                    }
                                    //console.log("li_content: " + JSON.stringify(li_content));
                                    return li_content;
                                }
                            })()  
                            }
                        </>
                        <span>{pageIndex < num_of_pages ? <a href={curr_path+"?pg=" + (pageIndex+1)} title="Next Page" class="pull-right col-sm-3 col-xs-2 nextBtn" onClick={e => pageClick(e, (pageIndex+1))}><span>Next</span></a> : <span class="pull-right col-sm-3 col-xs-2 disabled" aria-hidden="true">Next</span>}</span>
                    </span>
                </nav>
            )
        }
        else {
            return (
                <div class="job_results__pagination"></div>
            )
        }
    }  

    const pageClick = (e, selectedPageNum) => {
        if (e !== null) {
            e.preventDefault()
            RemovePageQSFromURL()
        }

        
        let dataIndexOfClickedPage =  Math.ceil(selectedPageNum / pagesToOneThousandResults) 
        //console.log("dataIndexOfClickedPage: " + dataIndexOfClickedPage);
        //console.log("dataIndex: " + dataIndex);
        //console.log("selectedPageNum: " + selectedPageNum);

        //check if the dataIndex matches the new dataIndex so we know if we're over 1k results
        if (dataIndex !== dataIndexOfClickedPage) {

            // if we're in the first 10k
            if(dataIndexOfClickedPage <= 10) { // 10 = (10k/1k)
                updateJobParams({"from" : (dataIndexOfClickedPage-1)*1000}) 
            }
            else {
                //if the suer clicks on the "next page", we can jsut grab the sort_key and return results that way. 
                if(dataIndexOfClickedPage === (dataIndex+1) && Object.keys(data).length>0) {
                    let sort_id = data.hits.hits.at(-1).sort[0]
                    updateJobParams({"from" : 0, "sort_id" : sort_id})                    
                }
                else {
                    //calculate how many times we need the api to "search after 
                    let search_afters_needed = (dataIndexOfClickedPage - 10); //calculate how many times we need the api to "search after 
                    updateJobParams({"search_after_count" : search_afters_needed}) 
                }
                
            }
            
            //setDataIndex(dataIndexOfClickedPage)
            
        }
        
        updatePageIndex(selectedPageNum);
        if (paginationParam === null) {scrollToTopOfJobs();}

    }

    const buildJobInfo = (num_results, results_per_page) => {
        let num_of_pages = Math.ceil(num_results/results_per_page);


        return (
            <div class="jobsFoundText col-xs-8 col-sm-12 text-left job-results-meta"><span>{num_results.toLocaleString("en-US")} {(parseInt(num_results) > 1) ? "Jobs" : "Job"} Found</span></div>
        )
    }

    const mobileMenuShow = () => {
        document.body.classList.add("mobile-facets-active");
    }


   
    if (typeof data.hits !== 'undefined') {
        if (paginationParam !== null && !isNaN(paginationParam) && paginationParamLoaded === false) {
            //logic for pg=x QS 
            setPaginationParamLoaded(true) //set to true so when this re-renders, it renders the HTML in the else if below
            pageClick(null, paginationParam) //set page 
        }
        else if((typeof data.hits !== 'undefined' && data.hits.total.value > 0 && paginationParam <= Math.ceil(data?.aggregations['job_count']["value"]/resultsPerPage))) {
            document.getElementById('job-detail') != null && (document.getElementById('job-detail').style.display = 'block') //show job detail
            return (
                
                <div class="jobCardsWrapper col-xs-12 col-sm-8" aria-label="Listing of Available Jobs">
                    <div class="facets-jobs-loading">
                        <img alt="A GIF of loading dots." src="/wp-content/themes/soliant/images/icons/jobs-loading.gif" id="progress" width="50" height="50"></img>
                    </div>
                   
                    {/*console.log("new pageIndex: " + pageIndex)*/}
                    {/*!loading && console.log("total jobs count using facet: " + data.aggregations['job_count']["value"])*/}
                    {/*!loading && console.log(data.hits.hits)*/}
                    {<div class="jobsFoundText col-xs-8 col-sm-12 text-left job-results-meta"><span>{data.aggregations['job_count']["value"].toLocaleString("en-US")} {(parseInt(data.aggregations['job_count']["value"]) > 1) ? "Jobs" : "Job"} Found</span></div>}
                    {<div class="col-xs-4 col-sm-12 text-right"><a href="javascript:void(0);" class="btn-red-filter btn-facet-menu pull-right hidden-sm" onClick={mobileMenuShow}>Filter</a></div>}
                    {
                        /** 
                        * to get right "offset" of pages, we need to (pageIndex-1 * resultsPerPage) so:
                        * page 1 will be (1-1) * 10 = offet 0 => pull results 0-9
                        * page 2 will be (2-1) * 10 = offet 10 => pull results 10-19
                        * page 3 will be (3-1) * 10 = offet 20 => pull results 20-29
                        **/
                    }
                    <div class="job-list" aria-label="Listing of Available Jobs">
                        {data.hits.hits?.slice(resultsOffset).map((row, index) => (  
                            
                                index < resultsPerPage && ( // <= show only x items 

                                <div class="clickable jobCards col-xs-12 col-sm-12" data-job-link={buildJobURL(row.fields.job_category[0], row.fields.job_city[0], row.fields.job_state_abbr[0], row.fields.job_postal[0], row.fields.job_order_id[0],row.fields.job_category_id[0])} >
                                    <div class="job-card__details">
                                        <h3 class="jobTitle" aria-level="2"><a class="jobTitleLink" href={buildJobURL(row.fields.job_category[0], row.fields.job_city[0], row.fields.job_state_abbr[0], row.fields.job_postal[0], row.fields.job_order_id[0],row.fields.job_category_id[0])} title={cleanJobTitle(row.fields.job_title[0])} data-id={row.fields.job_order_id[0]}>{cleanJobTitle(row.fields.job_title[0])}</a></h3>
                                        <span class="lblLocation">{row.fields.job_city[0]}, {row.fields.job_state_abbr[0]}</span>
                                        <div class="jobDesc">{JobDetailPreview(row.fields.job_description_raw[0])}</div>
                                    </div>
                                    <div class="jcFooter">
                                        <span class="lblJobCat hidden-xs hidden-sm col-sm-1 col-md-6">{removeMainCat(row.fields.job_category[0])}</span>
                                        <span class="lblJobType col-sm-4 col-xs-5 col-md-3">{(row.fields.job_type) && FixAnyOfTheseJobType(row.fields.job_type[0])}</span>
                                        <span class="lblDaysPosted col-xs-7 col-sm-5 col-md-3 pull-right">{formatShortDate(row.fields.modified_at[0])}</span>
                                    </div>
                                </div>
                                
                                )
                        ))}
                    </div>

                   
                    
                    {buildPagination(data.aggregations['job_count']["value"], resultsPerPage)}
                    {/*(!loading && !Object.keys(jobDetail).length>0) && console.log("JobDetails ON RENDER: " + JSON.stringify(jobDetail))*/}
                    {/*(paginationParam !== null || !isNaN(paginationParam)) && pageClick(null, paginationParam) /* check for page params */}

                    <div class="eeo-statement"><p><em>An Equal Opportunity Employer. All qualified applicants will receive consideration for employment without regard to race, color, religion, sex, sexual orientation, gender identity, national origin, or protected veteran status and will not be discriminated against on the basis of disability.</em></p></div>
                   
                </div>
        
        
            )
        }
        else {
            return(

                <div  className={(window.were_facets_used) ? "sec-NoJobsFound col-xs-12 col-sm-8" : "sec-NoJobsFound col-xs-12" }>
                    <section class="section-201 grey-bg">
                        <div class="noJobsFoundWrap">
                            <div class="noJobsFoundBlock">
                                <div class="media-object-default">
                                    <div class="media">
                                        <div class="media-left"> <img class="media-object" src="https://www.soliant.com/wp-content/themes/soliant/images/icons/no-jobs-were-found-computer-search.png" alt="An image of a laptop with a magnifying glass on the bottom left of it." width="192" height="160"></img></div>
                                        <div class="media-body">
                                            <h4>Looks like all of the openings in this category have been filled!</h4>
                                            <h5>Check back soon for new postings or click on a different category below!</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {(!window.were_facets_used) &&
                    <section class="hm-section-browseHealthcareJobs">
                        <div class="browseHealthcareJobsWrap">
                            <h2>Browse Healthcare Jobs</h2>
                            <div class="btToggleWrap">
                                <div class="btn-group" data-toggle="buttons">
                                    <label class="btn btn-primary bcat active">
                                    <input type="radio" name="options" id="byCategory" autocomplete="off" checked="" />by category</label>
                                    <label class="btn btn-primary bloc">
                                    <input type="radio" name="options" id="byLocation" autocomplete="off" />by location</label>
                                </div>
                            </div>
                            <div class="byCategoryPanel" style={{"display": "block"}}>
                                <ul class="center-block clearfix">
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/nursing-jobs/" class="btn-link-cta">Nursing Jobs</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/school-healthcare-jobs/" class="btn-link-cta">Schools Jobs</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/pharmacy-jobs/" class="btn-link-cta">Pharmacy Jobs</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/therapy-jobs/" class="btn-link-cta">Therapy Jobs</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/allied-health-jobs/" class="btn-link-cta">Allied Health Jobs</a></li>
                                </ul>
                            </div>
                            <div class="byLocationPanel" style={{"display": "none"}}>
                                <ul class="center-block clearfix">
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/jobs/?city=atlanta&amp;state=georgia" class="btn-link-cta">Atlanta, GA</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/jobs/?city=chicago&amp;state=illinois" class="btn-link-cta">Chicago, IL</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/jobs/?city=columbia&amp;state=south_carolina" class="btn-link-cta">Columbia, SC</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/jobs/?city=denver&amp;state=colorado" class="btn-link-cta">Denver, CO</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/jobs/?city=houston&amp;state=texas" class="btn-link-cta">Houston, TX</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/jobs/?city=los_angeles&amp;state=california" class="btn-link-cta">Los Angeles, CA</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/jobs/?city=phoenix&amp;state=arizona" class="btn-link-cta">Phoenix, AZ</a></li>
                                    <li class="col-md-4 col-sm-4 col-xs-12"><a href="/jobs/?city=seattle&amp;state=washington" class="btn-link-cta">Seattle, WA</a></li>
                                </ul>
                            </div>
                            <div class="clearfix"></div>
                            <div class="buttonWrap col-sm-3 col-md-4 btnWrapBrowsAllJobs"><a href="/jobs/" class="btn btn-default btn-default__secondary">Browse All</a></div>
                        </div>
                    </section>
                    }
                </div>
            )
        }
    } 
    else {
        return (

            <div class="jobs-are-loading">
                <div class="facets-jobs-loading">
                    <img alt="progress" src="/wp-content/themes/soliant/images/icons/jobs-loading.gif" id="progress" />
                </div>
            </div>
        )
       
    }

}

export default JobResults;



